import { Navigate } from 'react-router-dom';
import { useUserRole } from '@/hooks/useUserRole';

interface AdminGuardProps {
  children: React.ReactNode;
}

/**
 * AdminGuard — Protege rotas /admin/* verificando se o user tem role admin.
 * 
 * Corrige gap C13: qualquer user autenticado podia acessar /admin/*.
 * Agora, apenas users com role 'admin' no user_roles podem ver essas páginas.
 * 
 * Uso: Envolver em combinação com ProtectedRoute:
 *   <ProtectedRoute>
 *     <AdminGuard>
 *       <AdminLayout>...</AdminLayout>
 *     </AdminGuard>
 *   </ProtectedRoute>
 */
export function AdminGuard({ children }: AdminGuardProps) {
  const { isAdmin, loading } = useUserRole();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
